module.exports = __webpack_public_path__ + "img/abstract-shapes-4.df2e040f.svg";